import { Badge } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  days: PropTypes.number
}

const PreOrderBadge = ({ days }) => {

  const color = days === 0 ? 'success' : 'danger'
  const text  = days === 0 ? 'Ready Stock' : `PO ${days} Days`

  return (
    <Badge color={ color }>
      { text }
    </Badge>
  )
}

PreOrderBadge.propTypes = propTypes

export default PreOrderBadge